
import modalEvents from '@marketplace/mixins/modalEvents.js'

export default {
    name: 'NavItem',

    mixins: [modalEvents],

    props: {
        url: {
            type: String,
            required: false,
            default: null,
        },
        name: {
            type: String,
            required: true,
        },
    },
}
